<template>
    <div v-if="show" class="from-mobile mobile-cells-wrapper" :class="[columns.length > 1 ? 'mobile-cells-multi' : singleColClass, extraClass]">
        <div v-if="columns.length === 0" class="mobile-cell">
            <slot :value="null" :col="null">-</slot>
        </div>
        <div v-for="col in columns" :key="col.userId" class="mobile-cell" :class="{ 'has-divider': columns.length > 1 }">
            <slot :value="col.fields[field]" :col="col">{{ displayValue(col.fields[field]) }}</slot>
        </div>
    </div>
</template>

<script>

export default {
    name: 'MobileChangeLogCells',
    props: {
        field: {
            type: String,
            required: true
        },
        columns: {
            type: Array,
            required: true
        },
        show: {
            type: Boolean,
            default: false
        },

        singleColClass: {
            type: String,
            default: 'col-4'
        },

        extraClass: {
            type: String,
            default: ''
        }
    },
    methods: {
        displayValue(value) {
            return (value === null || value === undefined || value === '') ? '-' : value;
        }
    }
}
</script>

<style scoped>
.mobile-cells-multi {

    display: block;
    white-space: nowrap;
    flex: 0 0 auto;
}

.mobile-cells-multi .mobile-cell {
    display: inline-block !important;
    box-sizing: border-box !important;
    width: 250px !important;
    padding: 0 8px !important;
    margin: 0 !important;
    vertical-align: top;
    white-space: normal;
}

.mobile-cell.has-divider {
    border-left: 1px solid #ccc;
}

.mobile-cell.has-divider:first-child {
    border-left: none;
}
</style>
